const TEAMS_TABLE_READY = "teams-table-ready"
const SEARCH_TEXT_STATE = "teams-table-search-text-state"
const ROWS_PER_PAGE_STATE = "teams-table-rows-per-page-state"
const PAGINATION_STATE = "teams-table-pagination-state"

const TEAM_EMPLOYEE_ID_FOR_ACTION = "teams-table-team-employee-id-for-action"

const ATTRITION_SOURCE_ACTION="attrition-source-action"


const ADD_EMPLOYEE_ATTRITION_READY = "add-emplyee-attrition-ready"

const ADD_ATTENDANCE_TABLE_READY = "add-attendance-table-ready"

const initialState = {
    isTeamsTableReady: true,

    isAddEmployeeAttritionReady:true,
    isAddAttendanceTableReady:true,
    teams: {},
    
    teamEmployeeSelectedId: null,
    attritionSource:"",
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case TEAMS_TABLE_READY:
            return Object.assign({}, state, { isTeamsTableReady: action.payload })
        case ADD_ATTENDANCE_TABLE_READY:
            return Object.assign({}, state, { isAddAttendanceTableReady: action.payload })
        case ADD_EMPLOYEE_ATTRITION_READY:
            return Object.assign({}, state, { isAddEmployeeAttritionReady: action.payload })
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case TEAM_EMPLOYEE_ID_FOR_ACTION:
            return Object.assign({}, state, {teamEmployeeSelectedId:action.payload})

        case ATTRITION_SOURCE_ACTION:
            return Object.assign({}, state, {attritionSource:action.payload})



        default:
        return state
    
    }

}

export function teamTableReady(data) {
    return {
        type: TEAMS_TABLE_READY,
        payload: data
    }
}

export function addAttendanceTableReady(data) {
    return {
        type: ADD_ATTENDANCE_TABLE_READY,
        payload: data
    }
}



export function addEmployeeAttritionReady(data) {
    return {
        type: ADD_EMPLOYEE_ATTRITION_READY,
        payload: data
    }
}


export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}



export function teamEmployeeIdForAction(teamId){
    return{
        type:TEAM_EMPLOYEE_ID_FOR_ACTION,
        payload:teamId
    }
}

export function attritionSourceAction(teamId){
    return{
        type:ATTRITION_SOURCE_ACTION,
        payload:teamId
    }
}




// WEBPACK FOOTER //
// ./src/modules/Teams/redux/teams.js